export default "__VITE_ASSET__cJvHFfpn__"